// extracted by mini-css-extract-plugin
export var banner = "_ij-0";
export var closeButton = "_ij-2";
export var greenCheckmark = "_ij-3";
export var hereLink = "_ij-4";
export var titleIcon = "_ij-1";